import React, { useState, useEffect } from 'react';
import { FiMaximize } from 'react-icons/fi';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { setIsLogged, setUserDetails, setActiveDashboard } from '../../redux/slices/user.slice';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import Dropdown from 'react-bootstrap/Dropdown';
import { api, endpoint } from '../../api';
import { Spin } from 'antd';

const Header = ({ toggleShow, handle }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { userDetails, activeDashboard } = useSelector((state) => state.user);

  const [dashboardList, setDashboardList] = useState([]);
  const [display, setDisplay] = useState(activeDashboard);
  const [layout, setLayout] = useState('Layout 3×3');
  const [siteLocations, setSiteLocations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getSiteLocations = async (userDetails) => {
    setIsLoading(true);
    if (userDetails?.role === 'superAdmin') {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/site-location`, { withCredentials: true });
      if (response) {
        setIsLoading(false);
        setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      }
    }
    if (userDetails?.role === 'admin') {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/site-location/admin-sites/` + userDetails._id,
        { withCredentials: true }
      );
      if (response) {
        setIsLoading(false);
        setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      }
    }
    if (userDetails?.role === 'installer') {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/site-location/installer-sites/` + userDetails._id,
        { withCredentials: true }
      );
      if (response) {
        setIsLoading(false);
        setSiteLocations(response.data.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)));
      }
    }
  };

  const getDashboardList = async () => {
    setIsLoading(true);
    try {
      const { results } = await api.get(endpoint.dashboard_list);
      setDashboardList(results);
      if (results.length <= 0) {
        dispatch(setActiveDashboard(''));
        setDisplay('');
      } else {
        dispatch(setActiveDashboard(results[0]?._id));
        setDisplay(results[0]?._id);
      }
    } catch (error) {}
    setIsLoading(false);
  };

  useEffect(() => {
    getSiteLocations(userDetails);
  }, [userDetails]);

  useEffect(() => {
    getDashboardList();
  }, [location.pathname]);

  const logOut = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to logout.',
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${process.env.REACT_APP_API_URL}/user/logout`, {
            withCredentials: true,
          })
          .then((res) => {
            dispatch(setIsLogged(false));
            dispatch(setUserDetails({}));
            window.localStorage.clear();
            navigate('/');
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  };

  const handleHeaderChange = (e) => {
    setDisplay(e.target.value);
    dispatch(setActiveDashboard(e.target.value));
  };

  return (
    <Spin spinning={isLoading}>
      <div className="az-header">
        <div className="container-fluid">
          <div className="az-header-left d-block d-md-none mr-3">
            <button
              id="azSidebarToggle"
              className="bg-transparent border-0 az-header-menu-icon"
              onClick={() => toggleShow()}
            >
              <span></span>
            </button>
          </div>
          <div className="az-header-center">
            <div className="row">
              {location.pathname === '/' && (
                <div className="col-md-3">
                  <select
                    className="form-select"
                    value={display}
                    onChange={handleHeaderChange}
                    style={{ width: 'auto' }}
                  >
                    {/* <option value=""> Dashboard</option> */}
                    {/* <option value="Live Dashboard">Live Dashboard</option> */}
                    {dashboardList?.length > 0 &&
                      dashboardList.map((dashboard) => (
                        <option key={dashboard._id} value={dashboard._id}>
                          {' '}
                          {dashboard.name}{' '}
                        </option>
                      ))}
                  </select>
                </div>
              )}
            </div>
          </div>

          <div className="az-header-right">
            <div>
              <FiMaximize className="tx-16" />
            </div>
            <DropdownButton
              key={'down'}
              id={`dropdown-button-drop-down`}
              className="d-flex"
              drop={'down'}
              variant="none"
              title={
                <div className="az-img-user online">
                  <img src={userDetails?.avatar} alt="user" />
                </div>
              }
            >
              <div className="az-header-profile">
                <div className="az-img-user">
                  <img src={userDetails?.avatar} alt="" />
                </div>
                <h6>{userDetails?.name}</h6>
                <span className="text-capitalize">
                  {userDetails?.role === 'superAdmin' ? 'Super Admin' : userDetails?.role}
                </span>
              </div>
              <div className="nav">
                <Dropdown.Item eventKey="1">
                  <Link to="/settings" className="dropdown-item">
                    Settings
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item eventKey="1">
                  <Link to="/profile" className="dropdown-item">
                    Profile
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item eventKey="1">
                  <button className="dropdown-item border-0 bg-transparent" onClick={() => logOut()}>
                    Logout
                  </button>
                </Dropdown.Item>
              </div>
            </DropdownButton>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Header;
